import { API_endpoints } from "../config";

export const statistic8 = async (startDate = "", endDate = ""): Promise<any> => {
    try {
        const response = await fetch(API_endpoints.statistic8, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({startDate, endDate}),
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von statistik 8 Daten.");
        }
    

        return await response.json();

        
    } catch (error) {
        console.error("Fehler beim Laden von statistik 8 Daten:", error);
    }
};
